/*
 * Copyright (C) America Móvil S.A.B de C.V - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Juan Manuel Garcia Junco Moreno <manue.garcia@ironbit.com.mx>, March 2020
 */
export { autobind } from './autobind';
export { isPlainObject } from './isPlainObject';



// WEBPACK FOOTER //
// ./src/packages/core/lib/reflection/index.ts